module.exports = __webpack_public_path__ + "img/img_side_clef.bbb6f69d.png";